export default {
      id: "vector-top-usage",
      viewBox: "0 0 10 5",
      url: __webpack_public_path__ + "img/icons.svg#vector-top",
      toString: function () {
        return this.url;
      }
    }